"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var routeHmr_native_exports = {};
__export(routeHmr_native_exports, {
  getRouteHmrEpoch: () => getRouteHmrEpoch,
  subscribeRouteHmr: () => subscribeRouteHmr
});
module.exports = __toCommonJS(routeHmr_native_exports);
var routeHmrEpoch = 0;
var routeHmrListeners = /* @__PURE__ */ new Set();
var subscribeRouteHmr = function subscribeRouteHmr2(onStoreChange) {
  routeHmrListeners.add(onStoreChange);
  return function() {
    routeHmrListeners.delete(onStoreChange);
  };
};
var getRouteHmrEpoch = function getRouteHmrEpoch2() {
  return routeHmrEpoch;
};
if (process.env.NODE_ENV === "development") {
  globalThis.__VXRN_ON_MODULE_UPDATED__ = function(id) {
    try {
      var routeCache = typeof window === "undefined" ? void 0 : window.__oneRouteCache;
      if (typeof (routeCache === null || routeCache === void 0 ? void 0 : routeCache.clearFile) === "function") {
        routeCache.clearFile(id);
      }
    } catch (error) {
      console.error("[one] route cache eviction failed", error);
    }
  };
}
//# sourceMappingURL=routeHmr.native.js.map
